/**
 * Component: sa-job-list
 * Description: Job list accordion component with sticky header support
 */
if (!customElements.get('sa-job-list')) {
  class SaJobList extends HTMLElement {
    constructor() {
      super();
      this.handleCategoryClick = this.handleCategoryClick.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.ticking = false;
    }

    connectedCallback() {
      this.categories = this.querySelectorAll('.sa-job-list__category-header');
      this.categories.forEach(header => {
        header.addEventListener('click', this.handleCategoryClick);
      });

      // Listen to global scroll for dynamic sticky adjustment
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      // Initial check
      this.updateStickyPosition();
    }

    disconnectedCallback() {
      if (this.categories) {
        this.categories.forEach(header => {
          header.removeEventListener('click', this.handleCategoryClick);
        });
      }
      window.removeEventListener('scroll', this.handleScroll);
    }

    handleCategoryClick(e) {
      e.preventDefault();
      const header = e.currentTarget;
      const category = header.closest('.sa-job-list__category');
      
      // Toggle current category
      const isOpen = category.hasAttribute('open');
      if (isOpen) {
        category.removeAttribute('open');
      } else {
        category.setAttribute('open', '');
      }
    }

    handleScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.updateStickyPosition();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    updateStickyPosition() {
      // 1. Check if the global header exists and is currently visible/sticky
      // In many themes, the header might be sticky, or scrolling up reveals it.
      // We rely on CSS variable --header-height usually, but if the header scrolls out of view, 
      // we might want to stick to top: 0.
      
      // However, the user request is specific: 
      // "If header is not there (scrolled out), stick to top. If header is there, stick below header."
      
      // Strategy: Check if the main header is currently "stuck" or visible at the top.
      const header = document.querySelector('header-component') || document.querySelector('.header-wrapper');
      let topOffset = 0;

      if (header) {
        const rect = header.getBoundingClientRect();
        // If header bottom is positive (visible) and it's sticky/fixed
        // Or simply if the header is visible in the viewport.
        if (rect.bottom > 0) {
           // Header is visible. Sticky top should be at least header height.
           // But wait, if header scrolls away (static position), rect.bottom decreases.
           // If header is sticky, rect.bottom stays constant (height).
           topOffset = rect.bottom;
        } else {
           // Header is scrolled out of view.
           topOffset = 0;
        }
      }

      // Update CSS variable for our component
      this.style.setProperty('--dynamic-header-offset', `${topOffset}px`);
    }
  }

  customElements.define('sa-job-list', SaJobList);
}
